import { Component, inject } from '@angular/core';
import { BreadcrumbItem, PageHeaderComponent, TABLE_SERVICE_TOKEN, TableComponent } from 'bs-components';
import { AdminBinsTableService } from './admin-bins-table.service';
import { BinLocationLight } from '../../../core/models/storage/bin.model';
import { Router } from '@angular/router';
import { APP_ROUTE_ADMIN } from '../../../app-routing.module';
import { ADMIN_ROUTE_BINS } from './admin-bins.routes';

@Component({
  selector: 'app-admin-bins',
  templateUrl: './admin-bins.component.html',
  styleUrls: ['./admin-bins.component.scss'],
  providers: [{ provide: TABLE_SERVICE_TOKEN, useExisting: AdminBinsTableService }],
  host: { class: 'admin-bins-container' },
  imports: [PageHeaderComponent, TableComponent]
})
export class AdminBinsComponent {

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'GLOBAL.GLOBAL.ADMINISTRATION', url: `/${APP_ROUTE_ADMIN}` },
    { label: 'ADMIN.GLOBAL.BIN_MANAGEMENT', url: `/${APP_ROUTE_ADMIN}/${ADMIN_ROUTE_BINS}` }
  ];

  private readonly router = inject(Router);

  handleRowClick(bin: BinLocationLight): void {
    this.router.navigate(['/', APP_ROUTE_ADMIN, ADMIN_ROUTE_BINS, bin.id]);
  }
}
